// Salão dos Ecos (Expedições): o seu Eco, uma cópia fantasma do seu personagem, aceita contratos de caça e volta horas
// depois com experiência, o loot já vendido e um prêmio extra. A cada 10 expedições o Eco sobe de patente e traz mais.
import { useEffect, useState } from 'preact/hooks';
import type { Outfit } from '../../../../shared/src/protocol';
import { CONTRACT_SEALS, ECO_RANKS, ECO_RANK_STEP, EXPEDITION_BONUS_NAMES, EXPEDITION_SLOTS, ecoEfficiency, ecoRank, type Expedition, type ExpeditionState } from '../../../../shared/src/game/expeditions';
import { OutfitImage } from '../../screens/Characters';

const n = (v: number) => v.toLocaleString('pt-BR');
const big = (v: number) => (v >= 1_000_000 ? (v / 1_000_000).toLocaleString('pt-BR', { maximumFractionDigits: 1 }) + 'kk' : v >= 10_000 ? Math.round(v / 1000) + 'k' : n(v));
const fmt = (ms: number) => { const s = Math.max(0, Math.ceil(ms / 1000)), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60; return `${h}h ${String(m).padStart(2, '0')}m ${String(x).padStart(2, '0')}s`; };
const BONUS_ICON: Record<string, string> = { fragments: '💠', preycards: '🃏', dust: '✨', gem: '💎', marks: '🏛️' };

type St = { state: ExpeditionState; slots: number; rerollGold: number; vip?: boolean; est?: Record<number, { xp: number; gold: number }> };

export function Expeditions(props: { st: St | null; bank: number; outfit?: Outfit; outfitOf: (name: string) => Outfit | undefined; send: (op: 'start' | 'collect' | 'reroll', id?: number) => void }) {
  const [, tick] = useState(0);
  const [help, setHelp] = useState(false);
  useEffect(() => { const t = setInterval(() => tick((x) => x + 1), 1000); return () => clearInterval(t); }, []);
  if (!props.st) return <p class="muted">Carregando...</p>;
  const { state, slots, rerollGold, est = {} } = props.st;
  const now = Date.now();
  const rank = ecoRank(state.done), eff = Math.round(ecoEfficiency(state.done) * 100);
  const nextAt = (rank + 1) * ECO_RANK_STEP, maxRank = rank >= ECO_RANKS.length - 1;
  const ready = state.slots.filter((s) => s.ends <= now);
  const ghost = (cls = '') => (props.outfit ? <span class={'eco-ghost ' + cls}><OutfitImage outfit={props.outfit} /></span> : <span class={'eco-ghost ' + cls} />);
  const reward = (m: Expedition) => {
    const e = est[m.id];
    return (
      <div class="eco-reward">
        {e && <span title="Experiência estimada"><b class="eco-xp">~{big(e.xp)}</b> XP</span>}
        {e && <span title="Gold estimado (loot já vendido, vai para o banco)"><b class="eco-gold">~{big(e.gold)}</b> gp</span>}
        <span title={`Prêmio garantido: ${m.bonus[1]} ${EXPEDITION_BONUS_NAMES[m.bonus[0]]}`}>{BONUS_ICON[m.bonus[0]]} <b>{m.bonus[1]}</b> {EXPEDITION_BONUS_NAMES[m.bonus[0]]}</span>
      </div>
    );
  };
  const monsters = (m: Expedition) => (
    <div class="eco-mons">{(m.monsters ?? []).map((name) => { const o = props.outfitOf(name); return <span key={name} title={name}>{o ? <OutfitImage outfit={o} /> : null}</span>; })}</div>
  );
  return (
    <div class="eco">
      {/* cabeçalho: o Eco, a patente e o que ele rende */}
      <div class="eco-head">
        {ghost('big')}
        <div class="eco-head-txt">
          <div class="eco-title">Salão dos Ecos <button class="eco-help" onClick={() => setHelp(!help)} title="Como funciona">?</button></div>
          <div class="eco-rank"><b>{ECO_RANKS[rank]}</b> · traz <b class="eco-gold">{eff}%</b> do que você caçaria</div>
          <div class="eco-rankbar" title={maxRank ? 'Patente máxima' : `${state.done}/${nextAt} expedições para ${ECO_RANKS[rank + 1]}`}>
            <i style={{ width: (maxRank ? 100 : ((state.done - rank * ECO_RANK_STEP) / ECO_RANK_STEP) * 100) + '%' }} />
            <span>{maxRank ? `${state.done} expedições · patente máxima` : `${state.done} expedições · ${nextAt - state.done} para ${ECO_RANKS[rank + 1]} (+2%)`}</span>
          </div>
        </div>
      </div>
      {(help || state.done === 0) && (
        <div class="eco-steps">
          <div><i>📜</i><b>1. Escolha um contrato</b><small>Cada contrato é uma hunt do seu nível, com duração de 1 a 12 horas.</small></div>
          <div><i>👻</i><b>2. Seu Eco vai caçar</b><small>Uma cópia fantasma de você, com o seu equipamento. Você continua jogando normalmente.</small></div>
          <div><i>🎁</i><b>3. Volte e colete</b><small>Experiência, o loot já vendido (gold no banco) e um prêmio garantido. Cada 10 expedições: patente nova.</small></div>
        </div>
      )}

      {/* os Ecos: em expedição, livres ou bloqueados (VIP) */}
      <div class="eco-sec">Seus Ecos {ready.length > 1 && <button class="tb-button green eco-all" onClick={() => ready.forEach((s) => props.send('collect', s.mission.id))}>Coletar todos ({ready.length})</button>}</div>
      <div class="eco-slots">
        {Array.from({ length: EXPEDITION_SLOTS.vip }, (_, i) => {
          const s = state.slots[i];
          if (s) {
            const left = s.ends - now, total = s.mission.hours * 3600_000, done = left <= 0;
            const pct = Math.min(100, ((total - left) / total) * 100);
            return (
              <div key={i} class={'eco-slot' + (done ? ' ready' : ' away')}>
                <div class="eco-slot-top">{ghost(done ? 'back' : 'away')}<div><b>{s.mission.huntName}</b><small>{done ? 'Voltou! Toque em Coletar.' : `Caçando há ${fmt(total - left)}`}</small></div></div>
                <div class="eco-path"><i style={{ width: pct + '%' }} /><em style={{ left: `calc(${pct}% - 6px)` }} /><span>{done ? 'Pronto' : fmt(left)}</span></div>
                {reward(s.mission)}
                <button class={'tb-button' + (done ? ' green' : '')} disabled={!done} onClick={() => props.send('collect', s.mission.id)}>{done ? 'Coletar' : 'Em expedição'}</button>
              </div>
            );
          }
          if (i >= slots) return <div key={i} class="eco-slot locked"><span class="eco-lock">🔒</span><b>Eco extra</b><small>Disponível com VIP</small></div>;
          return <div key={i} class="eco-slot free">{ghost('idle')}<b>Eco livre</b><small>Escolha um contrato abaixo</small></div>;
        })}
      </div>

      {/* contratos do dia, em pergaminhos com selo por duração */}
      <div class="eco-sec">Contratos de hoje <small class="muted">· trocam todo dia à meia-noite</small></div>
      <div class="eco-board">
        {state.board.map((m) => {
          const seal = CONTRACT_SEALS[m.hours] ?? CONTRACT_SEALS[1]!;
          return (
            <div key={m.id} class="eco-contract" style={{ '--seal': seal.color } as any}>
              <span class="eco-seal" title={seal.name}>{m.hours}h</span>
              <small class="eco-kind">{seal.name}</small>
              {monsters(m)}
              <b class="eco-hunt">{m.huntName}</b>
              {m.level ? <small class="muted">Hunt level {m.level}+</small> : null}
              {reward(m)}
              <button class="tb-button green" disabled={state.slots.length >= slots} onClick={() => props.send('start', m.id)}>{state.slots.length >= slots ? 'Sem Eco livre' : 'Enviar Eco'}</button>
            </div>
          );
        })}
        {!state.board.length && <p class="muted small">Todos os contratos de hoje foram aceitos. Volte amanhã ou troque o quadro.</p>}
      </div>
      <div class="eco-foot">
        <button class="tb-button" disabled={props.bank < rerollGold} onClick={() => props.send('reroll')}>Trocar os contratos ({n(rerollGold)} gp)</button>
        <small class="muted">Valores estimados com o seu equipamento atual.</small>
      </div>
    </div>
  );
}
